"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableColumn = exports.EditableColumnContainer = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var RichTextEditor_1 = require("../RichTextEditor");
var TypeAhead_1 = require("./TypeAhead");
exports.EditableColumnContainer = styled_components_1.default.div.attrs({
    className: 'tws-editable-column',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tdisplay: table-cell;\n\t\tposition: relative;\n\t\toutline: none;\n\t\tvertical-align: top;\n\t\t&& {\n\t\t\t", "\n\t\t}\n\t}\n"], ["\n\t {\n\t\tdisplay: table-cell;\n\t\tposition: relative;\n\t\toutline: none;\n\t\tvertical-align: top;\n\t\t&& {\n\t\t\t", "\n\t\t}\n\t}\n"])), function (props) {
    return props.hasError ? 'border: 2px solid #e00000;' : props.editMode ? 'border: 1px solid #444444;' : 'border: 1px solid #cccccc;';
});
exports.EditableColumnContainer.displayName = 'EditableColumnContainer';
var Label = styled_components_1.default.label.attrs({
    className: 'tws-editable-label',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding: 10px;\n\tmargin: 0;\n\t", "\n\twidth: 100%;\n\theight: 100%;\n"], ["\n\tpadding: 10px;\n\tmargin: 0;\n\t", "\n\twidth: 100%;\n\theight: 100%;\n"])), function (props) { return (props.editMode ? 'color: #444444' : 'color: #999999;'); });
Label.displayName = 'Label';
var ValidatingIcon = (0, styled_components_1.default)('span').attrs({
    className: 'tws-editable-loading-icon',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tcolor: ", ";\n\tfont-size: 11pt;\n\ttext-align: center;\n\ttop: 10px\n\tright: 5px;\n"], ["\n\tposition: absolute;\n\tcolor: ", ";\n\tfont-size: 11pt;\n\ttext-align: center;\n\ttop: 10px\n\tright: 5px;\n"])), globalVars_module_scss_1.default.mainBlue);
ValidatingIcon.displayName = 'ValidatingIcon';
var ErrorIcon = (0, styled_components_1.default)(Common_1.Icon).attrs({
    className: 'tws-editable-error-icon',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\tcolor: ", ";\n\ttop: 10px;\n\tright: 5px;\n"], ["\n\tposition: absolute;\n\tcolor: ", ";\n\ttop: 10px;\n\tright: 5px;\n"])), globalVars_module_scss_1.default.red);
ErrorIcon.displayName = 'ErrorIcon';
var ErrorMessage = styled_components_1.default.div.attrs({
    className: 'tws-editable-error-message',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin: 5px 0 0 0;\n\tpadding: 0 10px 10px 10px;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tline-height: 1.1em;\n"], ["\n\tcolor: ", ";\n\tmargin: 5px 0 0 0;\n\tpadding: 0 10px 10px 10px;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tline-height: 1.1em;\n"])), globalVars_module_scss_1.default.red);
ErrorMessage.displayName = 'ErrorMessage';
var EditableColumn = /** @class */ (function (_super) {
    __extends(EditableColumn, _super);
    function EditableColumn(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEditing: _this.props.editMode,
        };
        _this.handleOnFocus = _this.handleOnFocus.bind(_this);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleOnSelect = _this.handleOnSelect.bind(_this);
        _this.handleOnPaste = _this.handleOnPaste.bind(_this);
        _this.handleOnSearch = _this.handleOnSearch.bind(_this);
        _this.handleTypeAheadOnChange = _this.handleTypeAheadOnChange.bind(_this);
        return _this;
    }
    EditableColumn.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.editMode !== this.props.editMode) {
            this.setState({ isEditing: nextProps.editMode });
        }
    };
    EditableColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, column = _a.column, deleted = _a.deleted, editMode = _a.editMode, existingEditable = _a.existingEditable, hasError = _a.hasError, isEmptyRow = _a.isEmptyRow, message = _a.message, record = _a.record, validating = _a.validating, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onPaste = _a.onPaste, onSearch = _a.onSearch, onSelect = _a.onSelect, rest = __rest(_a, ["className", "column", "deleted", "editMode", "existingEditable", "hasError", "isEmptyRow", "message", "record", "validating", "onBlur", "onChange", "onFocus", "onPaste", "onSearch", "onSelect"]);
        return (react_1.default.createElement(exports.EditableColumnContainer, __assign({}, rest, { tabIndex: 1, className: className, editMode: editMode, existingEditable: existingEditable, hasError: hasError, onFocus: this.handleOnFocus }),
            record.isNew || isEmptyRow || existingEditable ? (this.getEditableField(column.type)) : (react_1.default.createElement(Label, { editMode: editMode || false, hasError: hasError }, record && record[column.columnKey])),
            editMode && hasError && react_1.default.createElement(ErrorMessage, null, message),
            editMode && hasError && react_1.default.createElement(ErrorIcon, { name: 'error' }),
            editMode && record.isNew && validating && column.yesIndicator && (react_1.default.createElement(ValidatingIcon, null,
                react_1.default.createElement(__1.Loading, { width: '18px', height: '18px' })))));
    };
    EditableColumn.prototype.handleOnSelect = function (option, event) {
        var _a = this.props, column = _a.column, isEmptyRow = _a.isEmptyRow;
        this.setState({ isEditing: false });
        var needTriggerOnSelect = (isEmptyRow && option.code !== '') || !isEmptyRow;
        var onSelect = this.props.onSelect;
        if (onSelect && needTriggerOnSelect) {
            onSelect(column, option, event);
        }
    };
    EditableColumn.prototype.handleOnSearch = function (text, event) {
        var column = this.props.column;
        var onSearch = this.props.onSearch;
        if (onSearch) {
            onSearch(column.columnKey, text, event);
        }
    };
    EditableColumn.prototype.handleOnPaste = function (text, event) {
        var _a = this.props, column = _a.column, onPaste = _a.onPaste;
        if (onPaste) {
            onPaste(column, text, event);
        }
    };
    EditableColumn.prototype.getEditableField = function (type) {
        var _a = this.props, column = _a.column, deleted = _a.deleted, enableHtmlEditor = _a.enableHtmlEditor, hasError = _a.hasError, message = _a.message, typeAheadDisplayRenderer = _a.typeAheadDisplayRenderer, placeholder = _a.placeholder, record = _a.record, typeAheadOptions = _a.typeAheadOptions, htmlEditorMode = _a.htmlEditorMode, toolbarConfiguration = _a.toolbarConfiguration;
        var isEditing = this.state.isEditing;
        if (type === 'typeahead') {
            return (react_1.default.createElement(TypeAhead_1.TypeAhead, { text: record && record[column.columnKey], placeholder: placeholder, items: typeAheadOptions, isEditing: isEditing, deleted: deleted, displayRenderer: typeAheadDisplayRenderer, filteredItems: typeAheadOptions, maxLength: column.maxLength, minChar: column.minChar, remote: column.remote, onChange: this.handleTypeAheadOnChange, onSearch: this.handleOnSearch, onPaste: this.handleOnPaste, onSelect: this.handleOnSelect }));
        }
        else {
            var inputType = type === 'textarea' ? 'textarea' : 'input';
            return (react_1.default.createElement(RichTextEditor_1.DynamicTableCellEditor, { id: column.columnKey, deleted: deleted, enableHtmlEditor: enableHtmlEditor, error: hasError, messages: message ? [message] : [], inputType: inputType, maxRows: column.maxRows, minWidth: column.minWidth, maxWidth: column.maxWidth, minHeight: column.minHeight, maxHeight: column.maxHeight, maxLength: column.maxLength, readOnly: deleted, placeholder: placeholder, value: record && record[column.columnKey], width: column.width, onBlur: this.handleOnBlur, onChange: this.handleOnChange, onPaste: this.handleOnPaste, htmlEditorMode: htmlEditorMode, toolbarConfiguration: toolbarConfiguration }));
        }
    };
    EditableColumn.prototype.handleOnChange = function (text, event) {
        var _a = this.props, column = _a.column, onChange = _a.onChange;
        if (onChange) {
            onChange(column.columnKey, text, event);
        }
    };
    EditableColumn.prototype.handleTypeAheadOnChange = function (text, event) {
        var _a = this.props, column = _a.column, onChange = _a.onChange;
        if (onChange) {
            onChange(column.columnKey, text, event);
        }
    };
    EditableColumn.prototype.handleOnFocus = function (event) {
        var _a = this.props, deleted = _a.deleted, duplicated = _a.duplicated, editMode = _a.editMode, onFocus = _a.onFocus, record = _a.record;
        if (deleted || duplicated || !record.isNew) {
            return;
        }
        this.setState({ isEditing: editMode });
        if (onFocus) {
            onFocus(event);
        }
    };
    EditableColumn.prototype.handleOnBlur = function (text, event) {
        this.setState({ isEditing: this.props.editMode });
        var _a = this.props, column = _a.column, onBlur = _a.onBlur;
        if (onBlur) {
            onBlur(column.columnKey, text, event);
        }
    };
    // Default props
    EditableColumn.defaultProps = {
        enableHtmlEditor: false,
        existingEditable: false,
        hasError: false,
    };
    return EditableColumn;
}(react_1.default.Component));
exports.EditableColumn = EditableColumn;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
